//config
export const SET_CONFIG = 'SET_CONFIG';

//widget
export const SET_WIDGET = 'SET_WIDGET';

//options
export const UPDATE_OPTIONS = 'UPDATE_OPTIONS';

//exported
export const SET_EXPORTED = 'SET_EXPORTED';
